import { css, CSSObject } from '@emotion/react'

export const headerAssetOverrides: CSSObject = {
  height: 210,
  width: '100%',
}

export const contentWrapper = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  padding: '12px 15px 4px 15px',
})

export const titleStyleOverrides = (readOnly: boolean): CSSObject => ({
  fontFamily: 'Helvetica',
  fontSize: 24,
  fontWeight: 500,
  letterSpacing: '-1px',
  lineHeight: '28px',
  maxHeight: 'none',
  padding: 0,

  '.tiptap': {
    padding: 2,
  },

  '&:hover': {
    backgroundColor: readOnly ? 'transparent' : undefined,
  },
})

export const accountSubtitleStyleOverrides = (
  readOnly: boolean
): CSSObject => ({
  fontFamily: 'Helvetica',
  lineHeight: '14px',
  maxHeight: 48,
  minWidth: 225,
  maxWidth: 225,

  '&:hover': {
    backgroundColor: readOnly ? 'transparent' : undefined,
  },
})

export const fauxFollowButtonWrapper = css({
  color: '#0073B1',
  display: 'flex',
})

export const fauxFollowButtonText = css({
  fontSize: 14,
  fontWeight: 500,
  marginLeft: 2,
})

export const contentDocumentWrapper = css({
  padding: 4,
})

export const documentStyleOverrides = (readOnly: boolean) =>
  css({
    '.CollaborationTextEditor': {
      border: 'none',
      borderRadius: 0,
      cursor: 'text',
      margin: 0,
      minHeight: 242,
      width: '100%',

      '&:hover': {
        backgroundColor: readOnly ? 'transparent' : '#F4F5F7',
      },
    },

    '.CollaborationTextEditorContent': {
      padding: 0,
    },

    '.CollaborationTextEditorControlBar': {
      borderRadius: 0,
      bottom: 0,
      placeContent: 'center',
      position: 'sticky',
      width: '100%',
    },
  })
